// Use relative URL in production, localhost in development
const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5999/api');

/**
 * Helper to safely parse JSON response
 */
const safeJsonParse = async (response) => {
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    // If not JSON, return a structured error
    return { success: false, message: text || 'Sunucu hatası oluştu' };
  }
};

/**
 * Send quote request to backend
 * @param {Object} quoteData - Quote form data
 * @returns {Promise<Object>} Response data
 */
export const sendQuoteRequest = async (quoteData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/quotes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(quoteData),
    });

    const data = await safeJsonParse(response);

    if (!response.ok) {
      throw new Error(data.message || 'Teklif gönderilirken bir hata oluştu');
    }

    return data;
  } catch (error) {
    throw new Error(error.message || 'Sunucu ile bağlantı kurulamadı');
  }
};

/**
 * Send contact form to backend
 * @param {Object} contactData - Contact form data
 * @returns {Promise<Object>} Response data
 */
export const sendContactForm = async (contactData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contactData),
    });

    const data = await safeJsonParse(response);

    if (!response.ok) {
      throw new Error(data.message || 'Mesaj gönderilirken bir hata oluştu');
    }

    return data;
  } catch (error) {
    throw new Error(error.message || 'Sunucu ile bağlantı kurulamadı');
  }
};
